import { gql, useMutation } from '@apollo/client';
import { useLocation } from '@gatsbyjs/reach-router';

const CREATE_SUBMISSION = gql`
  mutation($input: createSubmissionInput) {
    createSubmission(input: $input) {
      submission {
        name
      }
    }
  }
`;

const useCreateSubmission = (formValues, name, id) => {
  const { origin, href } = useLocation();
  const [createLead, { data, loading, error }] = useMutation(CREATE_SUBMISSION);
  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      await createLead({
        variables: {
          input: {
            data: {
              form: id,
              fields: formValues,
              source: origin,
              url: href,
            },
          },
        },
      });
    } catch (err) {
      if (typeof Sentry === 'undefined') {
        console.warn('There is no Sentry, not sending...');
        return;
      }
      Sentry.captureException(err, (scope) => {
        scope.clear();
        scope.setContext('form', { name, href });
        scope.setContext('fields', formValues);
        return scope;
      });
    }
  };

  return {
    onSubmit,
    data,
    loading,
    error,
  };
};

export default useCreateSubmission;
